import packageJson from "../package.json" with { type: "json" };

export const TILE_EVENTS_VERSION = packageJson.version;

export * from "./events";
